// extracted by mini-css-extract-plugin
module.exports = {"info":"ShareAction_info__2pWRm"};